<template>
    <div class="client-profile settings-section">
        <p class="settings-section__heading">{{$t('project_settings.client_profile.title')}}</p>
        <div class="date__wrapper client-profile__wrapper">
            <div class="client-selection__inner">
                <div class="client-selection__left client-selection__option"
                     :class="{
                        'active': selectedProfile === RETAIL_TYPE
                    }"
                     @click.prevent="toggleProfileType(RETAIL_TYPE)"
                >
                    <div class="client-selection__box">
                        <div class="indicator"
                             :class="{
                                'checked': selectedProfile === RETAIL_TYPE
                             }"
                        >
                        </div>
                        <img src="@/assets/icons/retail-person.svg" :alt="$t('style_quiz.profile.retail_img')" />
                        <p>{{ $t('style_quiz.profile.retail') }}</p>
                    </div>
                    <p class="client-selection__text">
                        {{ $t('style_quiz.profile.retail_desc') }}
                    </p>
                </div>
                <div class="client-selection__right client-selection__option"
                     :class="{
                        'active': selectedProfile === BUSINESS_TYPE
                    }"
                     @click.prevent="toggleProfileType(BUSINESS_TYPE)"
                >
                    <div class="client-selection__box">
                        <div class="indicator"
                             :class="{
                                'checked': selectedProfile === BUSINESS_TYPE
                             }"
                        >
                        </div>
                        <img src="@/assets/icons/suitcase.svg" :alt="$t('style_quiz.profile.business_img')" />
                        <p>{{ $t('style_quiz.profile.business') }}</p>
                    </div>
                    <p class="client-selection__text">
                        {{ $t('style_quiz.profile.business_desc') }}
                    </p>
                </div>
            </div>
            <div class="client-profile__button project-add__button">
                <button
                    class="next"
                    @click.prevent="submitProfile"
                    :class="{'disabled': sendingForm}"
                    :disabled="sendingForm"
                >
                    <template v-if="!sendingForm">
                        {{ $t('project_settings.client_profile.save') }}
                    </template>
                    <template v-else>
                        {{ $t('project_settings.client_profile.saving') }}
                    </template>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {useI18n} from "vue-i18n";
import axios from "axios";
import authHelper from "@/helpsers/auth.helper";
import router from "@/router";
import ApiHelper from "@/helpsers/api.helper";
import {inject, ref, toRefs, watch} from "vue";
import AlertHelper from "@/helpsers/alert.helper";
import storeCache from "@/js/storeCache";

export default {
    name: "ClientProfile",
    props: {
        project: {
            type: Object,
            default: null
        }
    },
    setup(props) {
        const {t} = useI18n(),
            alert = inject('alert');
        const { project: projectDetails } = toRefs(props);
        let selectedProfile = ref('');
        const RETAIL_TYPE = 'RETAIL';
        const BUSINESS_TYPE = 'BUSINESS';
        const sendingForm = ref(false);

        watch(projectDetails, (newVal, oldVal) => {
            selectedProfile.value = projectDetails.value?.typeOfClient ?? '';
        })


        function saveBudget() {
            // const data = {
            //     id: router.currentRoute.value.params.id,
            //     budget: projectDetails.value.budget
            // }
            //
            // axios.put(ApiHelper.getEditProjectUrl(),data, {
            //     headers: authHelper.authHeader()
            // })
            // .then((result) => {
            //     AlertHelper.show(alert,t('project_settings.budget.save_success_title'),t('project_settings.budget.save_success_desc'));
            // })
            // .catch(({response}) => {
            //     let errorMessage = ApiHelper.getResponseMessage(response?.data?.code);
            //     AlertHelper.show(alert, errorMessage, '', 'error');
            // })
        }

        function toggleProfileType(type) {
            selectedProfile.value = type;
        }


        const submitProfile = async () => {
            sendingForm.value = true;
            const data = {
                id: router.currentRoute.value.params.id,
                typeOfClient: selectedProfile.value
            }

            axios.put(ApiHelper.getEditProjectUrl(), data, {
                headers: authHelper.authHeader()
            }).then((result) => {
                sendingForm.value = false;
                AlertHelper.show(alert, t('project_settings.client_profile.alert_success'));
            }).catch(({response}) => {
                sendingForm.value = false;
                let errorMessage = ApiHelper.getResponseMessage(response?.data?.code);
                AlertHelper.show(alert, errorMessage, '', 'error');
            })
        }



        return {
            projectDetails,
            saveBudget,
            selectedProfile,
            RETAIL_TYPE,
            BUSINESS_TYPE,
            toggleProfileType,
            submitProfile,
            sendingForm
        }
    }
}
</script>

<style scoped lang="scss">
@use '@/css/quiz';
@use '@/css/custom-quiz';

.client-profile {
    &__wrapper {
        padding: 20px 0 0 0 ;
        justify-content: space-around;
        display: flex;
        flex-direction: column;
    }
    &__button {
        width: 100%;
        text-align: right;
        padding: 30px 20px 10px 20px;

        z-index: 1;
        
        @media screen and (max-width: 500px) {
            text-align: center;
        }
        
        button {
            margin: 0;
            &:hover {
                cursor: pointer;
                background: #e35748;
            }
        }

    }

    .indicator {
        &.checked {
            background-color: #f4f3f3;
            border: 0;
            background-image: url("./../../../assets/icons/checkmark-dark.svg");
            background-position: center;
            background-repeat: no-repeat;
            background-size: 70%;
        }
    }

    .client-selection {
        &__option.active .client-selection__box {
            border: 1px solid #9e5d57
        }
    }
}
.client-selection__inner {
    display: grid;
    grid-template-columns: 1fr;
    width: 100%;
    gap: 20px;
    @media (min-width: 460px) {
        grid-template-columns: 1fr 1fr;
    }
}
.client-selection__right,
.client-selection__left  {
    margin: 0;
    align-items: center;
    justify-content: center;
}
.client-selection__text {
    max-width: 20ch;
    height: unset;
}
</style>